import {Permission} from "./enums";
import {AuthService} from "./services/api/v1/auth.service";
import {environment} from "../environments/environment";
import { TypeSales } from "./enums/type-sales.enum";


export interface MenuOptions {
  label: string;
  labelMenu?: string
  icon?: string
  class?: string
  img?: string;
  imgOverlay?: string
  alt?: string
  permission: keyof typeof Permission;
  action?: (link: string, authService: AuthService, formaVenta?: TypeSales) => void;
}

const onGotoAction = (link: string, authService: AuthService, formaVenta?: TypeSales) => {
  if(link == 'nueva') {
    let url = environment.global.country.code == 'MX'
      ? 'solicitud/terminos-y-condiciones'
      : 'solicitud/nueva';
    if (formaVenta === TypeSales.tienda || formaVenta === TypeSales.domicilio) {
      url += `?forma_venta=${formaVenta}`;
    }
    authService.gotoSalesModule(url);
  }else if(link == 'continuar') {
    authService.gotoSalesModule('solicitudes/pendientes');
  }else{
    authService.gotoSalesModule(link);
  }

}

export const newRequest: MenuOptions = {
  label: 'Nueva Solicitud de Crédito',
  icon: 'pi pi-empty',
  class: 'font-bold',
  img: 'assets/images/dashboard/nueva-solicitud-credito.jpg',
  imgOverlay: 'assets/images/dashboard/overlay.png',
  alt: 'Nueva Solicitud de Crédito',
  permission: 'Ventas.NuevaSolicitud',
  action: (link: string, authService: AuthService, formaVenta?: TypeSales) => {
    onGotoAction(link, authService, formaVenta);
  }
};


export const searchRequest: MenuOptions = {
  label: 'Buscar Solicitud de Crédito',
  icon: 'pi pi-empty',
  class: 'font-bold',
  img: 'assets/images/dashboard/buscar-solicitud.jpg',
  imgOverlay: 'assets/images/dashboard/overlay.png',
  alt: 'Buscar Solicitud de Crédito',
  permission: 'SolicitudPago.Buscar',
  action: (link: string, authService: AuthService, formaVenta?: TypeSales) => {
    onGotoAction(link, authService, formaVenta);
  }
};

export const generateRequest: MenuOptions = {
  label: 'Generar Solicitud de Crédito',
  labelMenu: 'Generar Solicitud de Crédito',
  icon: 'pi pi-empty',
  class: 'font-bold',
  imgOverlay: 'assets/images/dashboard/overlay.png',
  img: 'assets/images/dashboard/generar-solicitud.jpg',
  alt: 'Generar Solicitud de Crédito',
  permission: 'SolicitudPago.GenerarPagoTerceros',
  action: (link: string, authService: AuthService, formaVenta?: TypeSales) => {
    onGotoAction(link, authService, formaVenta);
  }

}

export const continueRequest: MenuOptions = {
  label: 'Continuar Solicitud de Crédito',
  labelMenu: 'Continuar Solicitud de Crédito Existente',
  icon: 'pi pi-empty',
  class: 'font-bold',
  imgOverlay: 'assets/images/dashboard/overlay.png',
  img: 'assets/images/dashboard/continuar-solicitud-credito.jpg',
  alt: 'Continuar Solicitud de Crédito Existente',
  permission: 'Ventas.ContinuarSolicitud',
  action: (link: string, authService: AuthService, formaVenta?: TypeSales) => {
    onGotoAction(link, authService, formaVenta);
  }

}

export const viewCatalog: MenuOptions = {
  label: 'Ver catálogo',
  icon: 'pi pi-empty',
  class: 'font-bold',
  imgOverlay: 'assets/images/dashboard/overlay.png',
  img: 'assets/images/dashboard/ver-catalogo.jpg',
  alt: 'Ver catálogo',
  permission: 'Ventas.VerCatalogo',
  action: (link: string, authService: AuthService) => {
    onGotoAction(link, authService);

  }

}

export const preCreditRating: MenuOptions = {
  label: 'Pre-calificación de crédito',
  icon: 'pi pi-empty',
  class: 'font-bold',
  imgOverlay: 'assets/images/dashboard/overlay.png',
  img: 'assets/images/dashboard/precalificacion-credito.jpg',
  alt: 'Pre-calificación de crédito',
  permission: 'Ventas.PrecalificacionCredito',
  action: (link: string, authService: AuthService, formaVenta?: TypeSales) => {
    onGotoAction(link, authService, formaVenta);
  }

}

export const saleReports: MenuOptions = {
  label: 'Reportes de ventas',
  icon: 'pi pi-empty',
  class: 'font-bold',
  imgOverlay: 'assets/images/dashboard/overlay.png',
  img: 'assets/images/dashboard/reportes-ventas.jpg',
  alt: 'Reportes de ventas',
  permission: 'Reportes.Ventas',
  action: (link: string, authService: AuthService, formaVenta?: TypeSales) => {
    onGotoAction(link, authService, formaVenta);
  }

}

export const storePaymentReports : MenuOptions = {
  label: 'Reportes de pagos en tienda',
  icon: 'pi pi-empty',
  class: 'font-bold',
  imgOverlay: 'assets/images/dashboard/overlay.png',
  img: 'assets/images/dashboard/reportes-pagos-tiendas.jpg',
  alt: 'Reportes de pagos en tienda',
  permission: 'Reportes.PagosTienda',
  action: (link: string, authService: AuthService) => {
    onGotoAction(link, authService);

  }

}

export const searchPaymentRequest: MenuOptions = {
  label: 'Buscar solicitud de pago',
  icon: 'pi pi-empty',
  class: 'font-bold',
  imgOverlay: 'assets/images/dashboard/overlay.png',
  img: 'assets/images/dashboard/buscar-solicitud-pago.jpg',
  alt: 'Buscar solicitud de pago',
  permission: 'SolicitudPago.Buscar',
  action: (link: string, authService: AuthService) => {
    onGotoAction(link, authService);

  }

}

export const thirdPartyPaymentRequest : MenuOptions = {
  label: 'Generar pagos para terceros',
  icon: 'pi pi-empty',
  class: 'font-bold',
  imgOverlay: 'assets/images/dashboard/overlay.png',
  img: 'assets/images/dashboard/generar-pagos.jpg',
  alt: 'Generar pagos para terceros',
  permission: 'SolicitudPago.GenerarPagoTerceros',
  action: (link: string, authService: AuthService) => {
    onGotoAction(link, authService);

  }

}

export const closingReport: MenuOptions = {
  label: 'Reporte de cierre',
  icon: 'pi pi-empty',
  class: 'font-bold',
  imgOverlay: 'assets/images/dashboard/overlay.png',
  img: 'assets/images/dashboard/reportes-ventas.jpg',
  alt: 'Reporte de cierre',
  permission: 'Reportes',
}
